import React from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import OutlinedButton from 'components/atoms/OutlinedButton';
import i18next from 'i18next';

const styles = () => ({});

class ModifyOutlinedButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * 수정 클릭
   * @param {string} name
   * @param {*} value
   */
  handleOnClick = () => e => {
    this.props.modifyClick(this.props.orderNumber);
  };

  componentDidMount() {}

  render() {
    const { handleOnClick } = this;

    return (
      <OutlinedButton
        className="mb-product-code-button"
        onClick={handleOnClick()}
        noneBorder
      >
        {i18next.t('수정')}
      </OutlinedButton>
    );
  }
}

export default withTranslation()(withStyles(styles)(ModifyOutlinedButton));
